// @flow

import React, { PureComponent } from "react";
import styled from "styled-components";

const SVG = styled.svg`
  display: block;
`;

export default class PickBetsPicture extends PureComponent<*> {
  render() {
    return (
      <SVG
        xmlns="http://www.w3.org/2000/svg"
        width="375"
        height="134"
        viewBox="0 0 375 134"
      >
        <defs>
          <path id="reuse-0" d="M0 0h16v16H0z" />
          <path
            id="g"
            d="M12.066 4.816a.472.472 0 00-.664.06l-4.375 5.251-2.46-2.46a.47.47 0 00-.665.666l2.824 2.824a.47.47 0 00.333.137h.02a.47.47 0 00.341-.17l4.706-5.646a.47.47 0 00-.06-.662z"
          />
        </defs>
        <defs>
          <linearGradient id="b" x1="0%" x2="88.738%" y1="26.835%" y2="75.158%">
            <stop offset="0%" stopColor="#CFD6DB" />
            <stop offset="53.204%" stopColor="#F0F3F8" />
            <stop offset="53.692%" stopColor="#CFD6DB" />
            <stop offset="100%" stopColor="#CFD6DB" />
          </linearGradient>
          <linearGradient id="d" x1="0%" x2="88.738%" y1="27.672%" y2="74.25%">
            <stop offset="0%" stopColor="#CFD6DB" />
            <stop offset="53.204%" stopColor="#F0F3F8" />
            <stop offset="53.692%" stopColor="#CFD6DB" />
            <stop offset="100%" stopColor="#CFD6DB" />
          </linearGradient>
          <linearGradient id="f" x1="0%" x2="88.738%" y1="27.068%" y2="74.905%">
            <stop offset="0%" stopColor="#CFD6DB" />
            <stop offset="53.204%" stopColor="#F0F3F8" />
            <stop offset="53.692%" stopColor="#CFD6DB" />
            <stop offset="100%" stopColor="#CFD6DB" />
          </linearGradient>
          <linearGradient id="j" x1="36.357%" x2="60.57%" y1="0%" y2="104.302%">
            <stop offset="0%" stopColor="#41E878" />
            <stop offset="53.692%" stopColor="#41E878" />
            <stop offset="54.182%" stopColor="#36C565" />
            <stop offset="100%" stopColor="#36C565" />
          </linearGradient>
          <linearGradient id="m" x1="36.357%" x2="60.57%" y1="0%" y2="104.302%">
            <stop offset="0%" stopColor="#41E878" />
            <stop offset="53.692%" stopColor="#41E878" />
            <stop offset="54.182%" stopColor="#36C565" />
            <stop offset="100%" stopColor="#36C565" />
          </linearGradient>
          <path
            id="a"
            d="M30.146 81V70.475h3.937L37.257 81h6.628L40.27 70.154c2.33-.777 3.495-2.638 3.495-5.584v-5.665c0-1.901-.51-3.36-1.527-4.378C41.22 53.509 39.761 53 37.86 53H24v28h6.146zm6.468-15.747h-6.468v-7.03h6.468c.67 0 1.004.334 1.004 1.004v5.021c0 .67-.334 1.005-1.004 1.005zM65.136 81v-5.343h-5.744V53H47.179v5.343h6.066v17.314H47.18V81h17.957z"
          />
          <path
            id="c"
            d="M92.111 81V70.535h3.915L99.18 81h6.59l-3.594-10.785c2.317-.772 3.475-2.623 3.475-5.552v-5.632c0-1.89-.506-3.342-1.518-4.353-1.012-1.012-2.463-1.518-4.354-1.518H86V81h6.111zm6.431-15.658h-6.43v-6.99h6.43c.666 0 .999.333.999.999v4.993c0 .666-.333.998-.999.998zM127.9 81v-5.312h-12.382v-2.836c0-.64.333-1.079.998-1.318l7.07-2.477c2.583-.905 3.875-2.623 3.875-5.153v-5.032c0-1.891-.506-3.342-1.518-4.354S123.48 53 121.589 53h-6.151c-1.89 0-3.342.506-4.354 1.518s-1.518 2.463-1.518 4.354v3.594h5.952v-3.235c0-.666.333-.998.998-.998h3.835c.666 0 .999.332.999.998v4.354c0 .639-.333 1.065-1 1.278l-6.51 2.237c-2.956 1.012-4.433 2.902-4.433 5.672V81H127.9z"
          />
          <path
            id="e"
            d="M154.077 80.841V70.435h3.892l3.137 10.406h6.554l-3.575-10.723c2.304-.768 3.455-2.608 3.455-5.52v-5.6c0-1.88-.503-3.324-1.509-4.33-1.006-1.006-2.449-1.51-4.329-1.51H148v27.683h6.077zm6.394-15.569h-6.394v-6.95h6.394c.662 0 .993.331.993.993v4.964c0 .662-.331.993-.993.993zM183.506 81c1.88 0 3.323-.503 4.33-1.51 1.006-1.005 1.509-2.448 1.509-4.328v-4.488c0-2.33-.993-3.787-2.979-4.369 1.615-.662 2.423-2.065 2.423-4.21v-3.257c0-1.88-.503-3.323-1.51-4.329C186.273 53.503 184.83 53 182.95 53h-6.195c-1.827 0-3.23.503-4.21 1.51-.98 1.005-1.47 2.448-1.47 4.328v2.383h5.918v-2.065c0-.662.33-.993.993-.993h3.733c.662 0 .993.331.993.993v3.972c0 .662-.33.993-.993.993h-4.806v5.044h5.362c.662 0 .993.33.993.992v4.727c0 .662-.33.993-.993.993h-4.408c-.662 0-.993-.331-.993-.993v-2.105h-5.918v2.383c0 1.88.49 3.323 1.47 4.329.98 1.006 2.383 1.509 4.21 1.509h6.87z"
          />
          <path
            id="l"
            d="M313.107 85v-4.855h1.1c2.167 0 3.831-.58 4.991-1.74 1.16-1.16 1.74-2.825 1.74-4.993v-6.32c0-2.535-1.388-4.168-4.167-4.901l-9.573-2.565c-.671-.183-1.007-.61-1.007-1.282v-3.481c0-.764.382-1.145 1.145-1.145h5.175c.764 0 1.145.381 1.145 1.145v2.885h6.917v-3.16c0-2.168-.565-3.832-1.695-4.993-1.13-1.16-2.748-1.74-4.855-1.74h-.916V43h-6.092v4.855h-1.007c-2.168 0-3.832.58-4.993 1.74-1.16 1.16-1.74 2.825-1.74 4.993v5.359c0 1.404.351 2.526 1.053 3.366.703.84 1.527 1.397 2.474 1.672l10.076 2.702c.733.214 1.1.595 1.1 1.145v4.305c0 .764-.383 1.145-1.146 1.145h-5.77c-.764 0-1.146-.381-1.146-1.145v-2.61H299v2.885c0 2.168.565 3.832 1.695 4.993 1.13 1.16 2.748 1.74 4.855 1.74h1.465V85h6.092z"
          />
          <use xlinkHref="#g" />
          <use id="h" xlinkHref="#g" />
          <use id="i" xlinkHref="#g" />
          <filter
            id="k"
            width="113.7%"
            height="111.9%"
            x="-6.8%"
            y="-3.6%"
            filterUnits="objectBoundingBox"
          >
            <feMorphology
              in="SourceAlpha"
              operator="dilate"
              radius=".5"
              result="shadowSpreadOuter1"
            />
            <feOffset
              dy="2"
              in="shadowSpreadOuter1"
              result="shadowOffsetOuter1"
            />
            <feComposite
              in="shadowOffsetOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowOffsetOuter1"
            />
            <feColorMatrix
              in="shadowOffsetOuter1"
              values="0 0 0 0 0.129411765 0 0 0 0 0.596078431 0 0 0 0 0.282352941 0 0 0 1 0"
            />
          </filter>
          <filter
            id="n"
            width="100%"
            height="100%"
            x="0%"
            y="0%"
            filterUnits="objectBoundingBox"
          >
            <feGaussianBlur in="SourceGraphic" />
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <path fill="#F8FBFF" d="M0 0h375v134H0z" />
          <g fillRule="nonzero">
            <use fill="#EBF6FF" xlinkHref="#a" />
            <use fill="url(#b)" stroke="#99A8B1" xlinkHref="#a" />
          </g>
          <g fillRule="nonzero">
            <use fill="#EBF6FF" xlinkHref="#c" />
            <use fill="url(#d)" stroke="#99A8B1" xlinkHref="#c" />
          </g>
          <g fillRule="nonzero">
            <use fill="#EBF6FF" xlinkHref="#e" />
            <use fill="url(#f)" stroke="#99A8B1" xlinkHref="#e" />
          </g>
          <g transform="translate(179 43)">
            <circle
              cx="8"
              cy="8"
              r="8"
              fill="#36C565"
              fillRule="nonzero"
              stroke="#219848"
              strokeWidth=".8"
            />
            <use xlinkHref="#reuse-0" />
            <use fill="#FFF" xlinkHref="#g" />
          </g>
          <g transform="translate(120 43)">
            <circle
              cx="8"
              cy="8"
              r="8"
              fill="#36C565"
              fillRule="nonzero"
              stroke="#219848"
              strokeWidth=".8"
            />
            <use xlinkHref="#reuse-0" />
            <use fill="#FFF" xlinkHref="#h" />
          </g>
          <g transform="translate(57 43)">
            <circle
              cx="8"
              cy="8"
              r="8"
              fill="#36C565"
              fillRule="nonzero"
              stroke="#219848"
              strokeWidth=".8"
            />
            <use xlinkHref="#reuse-0" />
            <use fill="#FFF" xlinkHref="#i" />
          </g>
          <path
            fill="#36C565"
            fillRule="nonzero"
            stroke="#219848"
            strokeWidth=".8"
            d="M240.016 66.264v-3.552h-11.744v3.552h11.744zm0 6.464v-3.552h-11.744v3.552h11.744z"
          />
          <circle
            cx="338.026"
            cy="83.128"
            r="5.128"
            fill="#FFCB4D"
            fillRule="nonzero"
            opacity=".5"
          />
          <circle
            cx="287.205"
            cy="85.846"
            r="2.564"
            fill="#FFCB4D"
            fillRule="nonzero"
            opacity=".6"
            transform="matrix(-1 0 0 1 574.41 0)"
          />
          <circle
            cx="262.846"
            cy="51.231"
            r="3.846"
            fill="#FFCB4D"
            fillRule="nonzero"
            transform="matrix(-1 0 0 1 525.692 0)"
          />
          <circle
            cx="300.026"
            cy="37.128"
            r="5.128"
            fill="#FFCB4D"
            fillRule="nonzero"
            opacity=".5"
            transform="matrix(-1 0 0 1 600.051 0)"
          />
          <circle
            cx="347.205"
            cy="45.846"
            r="2.564"
            fill="#FFCB4D"
            fillRule="nonzero"
            opacity=".6"
          />
          <path
            fill="url(#j)"
            fillRule="nonzero"
            stroke="#219848"
            d="M286.39 75v-2.543h.575c1.136 0 2.007-.304 2.615-.912.608-.608.912-1.48.912-2.615h0v-3.31c0-1.328-.728-2.184-2.183-2.568h0l-5.015-1.343c-.351-.096-.527-.32-.527-.672h0v-1.823c0-.4.2-.6.6-.6h2.71c.4 0 .6.2.6.6h0v1.511h3.623V59.07c0-1.136-.296-2.007-.888-2.615-.592-.608-1.44-.912-2.543-.912h0-.48V53h-3.19v2.543h-.528c-1.136 0-2.008.304-2.615.912-.608.608-.912 1.48-.912 2.615h0v2.807c0 .736.184 1.323.552 1.763.368.44.8.732 1.295.876h0l5.278 1.415c.384.112.576.312.576.6h0v2.255c0 .4-.2.6-.6.6h0-3.023c-.4 0-.6-.2-.6-.6h0V67.42H279v1.511c0 1.136.296 2.007.888 2.615.591.608 1.44.912 2.543.912h.767V75h3.191zm50 0v-2.543h.575c1.136 0 2.007-.304 2.615-.912.608-.608.912-1.48.912-2.615h0v-3.31c0-1.328-.728-2.184-2.183-2.568h0l-5.015-1.343c-.351-.096-.527-.32-.527-.672h0v-1.823c0-.4.2-.6.6-.6h2.71c.4 0 .6.2.6.6h0v1.511h3.623V59.07c0-1.136-.296-2.007-.888-2.615-.592-.608-1.44-.912-2.543-.912h0-.48V53h-3.19v2.543h-.528c-1.136 0-2.008.304-2.615.912-.608.608-.912 1.48-.912 2.615h0v2.807c0 .736.184 1.323.552 1.763.368.44.8.732 1.295.876h0l5.278 1.415c.384.112.576.312.576.6h0v2.255c0 .4-.2.6-.6.6h0-3.023c-.4 0-.6-.2-.6-.6h0V67.42H329v1.511c0 1.136.296 2.007.888 2.615.591.608 1.44.912 2.543.912h.767V75h3.191z"
          />
          <g fillRule="nonzero">
            <use fill="#000" filter="url(#k)" xlinkHref="#l" />
            <use fill="url(#m)" stroke="#219848" xlinkHref="#l" />
          </g>
          <ellipse
            cx="310"
            cy="99"
            fill="#EBF6FF"
            filter="url(#n)"
            rx="13"
            ry="3"
          />
        </g>
      </SVG>
    );
  }
}
